export default "__VITE_ASSET___0vYRxNA__"